import Reveal from "./Reveal";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { NEWS } from "@/config/clinicConfig";

export default function News() {
  return (
    <section id="news" data-testid="in-the-news-section" className="bg-espresso pb-24 pt-5 text-cream lg:pb-32 lg:pt-6">
      <div className="mx-auto max-w-6xl px-5 lg:px-8">
        <div className="flex flex-wrap items-start justify-between gap-6">
          <div>
            <h2 className="font-display text-3xl font-medium tracking-tight sm:text-4xl lg:text-[2.75rem]">
              {NEWS.heading}
            </h2>
          </div>
          <p className="max-w-xs text-[13px] leading-snug text-cream/60">{NEWS.note}</p>
        </div>

        <Reveal delay={0.1}>
          <Carousel data-testid="news-carousel" className="mt-10" opts={{ align: "start", loop: true }}>
            <CarouselContent>
              {NEWS.items.map((item) => (
                <CarouselItem key={item.id} className="basis-full sm:basis-1/2 lg:basis-1/3">
                  <div
                    data-testid={`news-slide-${item.id}`}
                    className="flex h-full flex-col overflow-hidden rounded-3xl bg-cream shadow-[0_24px_60px_-30px_rgba(0,0,0,0.55)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5"
                  >
                    <div className="flex aspect-square items-center justify-center p-3">
                      <img
                        src={item.image}
                        alt={`${item.outlet} — ${item.headline}`}
                        loading="lazy"
                        className="h-full w-full rounded-2xl object-contain"
                      />
                    </div>
                    <div className="border-t border-espresso/10 px-5 py-4">
                      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-clay">{item.outlet}</p>
                      <p className="mt-1.5 font-display text-[15px] font-semibold leading-snug tracking-tight text-espresso">
                        {item.headline}
                      </p>
                      <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.16em] text-cocoa/70">
                        {item.date}
                      </p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious
              data-testid="news-prev-button"
              className="-left-3 h-10 w-10 rounded-full border-cream/25 bg-cream text-espresso hover:bg-gold lg:-left-5"
            />
            <CarouselNext
              data-testid="news-next-button"
              className="-right-3 h-10 w-10 rounded-full border-cream/25 bg-cream text-espresso hover:bg-gold lg:-right-5"
            />
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
}
